// This function will take a vue-router query object, and array of keys and will remap this array of keys/values to a new object
// This is usefull if we need to map multiple (or just some) values from query object to different objects e.g. pagination && filters
// view "views/projects/project.vue" created() to see it in action
// "keys" can have 3 different formats: 
//    - primitive "key"
//    - object {"small_key" : "smallKey"} - to be able to take query param "small_key" and return it as "smallKey"
//    - array ["articles"] : will return as articles[index][id] : value

export function mapParamsFromURL(query, keys) {
  let obj = {}
  keys.forEach(key => {
    if(Array.isArray(key)) {
      let extractedKeys = Object.keys(query).filter(q => q.includes(key))
      extractedKeys.forEach(ek => {
        obj[ek] = query[ek]
      })
      return
    }
    if(key instanceof Object) {
      const params = Object.entries(key)
      const value = query[params[0][0]]
      const paramKey = [params[0][1]]
      if(value || value === 0) obj[paramKey] = value
      return
    }
    if(query[key] || query[key] === 0) obj[key] = query[key]
  })
  return obj
}